export default "__VITE_ASSET__DB45YmUw__";